import cn from "classnames";
import React from "react";
import styles from "./Icon.scss";

export const TYPES = {
  ABOUTUS: "ABOUTUS",
  SLIDES: "SLIDES",
  SOURCE: "SOURCE",
  SPEAK: "SPEAK",
  FAQ: "FAQ",
  CONTACTUS: "CONTACTUS",
  ISSUES: "ISSUES",
  TWITTER: "TWITTER",
  FACEBOOK: "FACEBOOK",
  LINKEDIN: "LINKEDIN",
  GITHUB: "GITHUB",
  YOUTUBE: "YOUTUBE"
};

Icon.propTypes = {
  className: React.PropTypes.string,
  title: React.PropTypes.string,
  type: React.PropTypes.oneOf(Object.keys(TYPES)).isRequired,
  viewBox: React.PropTypes.string,
  height: React.PropTypes.string,
  width: React.PropTypes.string
};

Icon.defaultProps = {
  viewBox: "0 0 24 24",
  height: "12",
  width: "12"
};

export default function Icon({ className, title, type, viewBox, height, width }) {
  return (
    <svg
      className={cn(styles.Icon, className)}
      height={height}
      title={title}
      viewBox={viewBox}
      width={width}
    >
      <path d="M0 0h24v24H0V0z" fill="none" />

      {getIconData(type)}
    </svg>
  );
}

export function getIconData(type) {
  switch (type) {
    case TYPES.ABOUTUS:
      return <path d="M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z" />;
    case TYPES.SLIDES:
      return (
        <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z" />
      );
    case TYPES.SOURCE:
      return (
        <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z" />
      );
    case TYPES.FAQ:
      return (
        <path d="M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z" />
      );
    case TYPES.CONTACTUS:
      return (
        <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z" />
      );
    case TYPES.ISSUES:
      return (
        <path d="M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z" />
      );
    case TYPES.SPEAK:
      return <path d="M16 3h-16v14h16l6 6z" />;
    case TYPES.TWITTER:
      return <path d="M10.064 26c-3.708 0-7.159-1.087-10.064-2.949.514.061 1.036.092 1.566.092 3.076 0 5.907-1.049 8.153-2.81-2.873-.053-5.297-1.951-6.133-4.558.401.077.812.118 1.235.118.599 0 1.179-.08 1.73-.23-3.003-.603-5.266-3.256-5.266-6.436 0-.028 0-.055.001-.083.885.492 1.898.787 2.974.821-1.762-1.177-2.921-3.186-2.921-5.463 0-1.203.324-2.33.889-3.3 3.238 3.971 8.076 6.584 13.532 6.858-.112-.48-.17-.981-.17-1.496 0-3.625 2.94-6.564 6.565-6.564 1.888 0 3.595.797 4.792 2.073 1.495-.294 2.901-.841 4.169-1.593-.49 1.533-1.531 2.819-2.887 3.631 1.328-.159 2.593-.511 3.771-1.034-.88 1.316-1.993 2.472-3.276 3.398.013.281.019.565.019.849 0 8.674-6.603 18.675-18.679 18.675" />;
    case TYPES.FACEBOOK:
      return <path d="M30.234 0h-28.468c-.976 0-1.766.791-1.766 1.766v28.468c0 .975.79 1.766 1.766 1.766h15.326v-12.392h-4.17v-4.829h4.17v-3.562c0-4.133 2.524-6.384 6.212-6.384 1.766 0 3.284.132 3.727.19v4.319l-2.557.001c-2.005 0-2.393.953-2.393 2.351v3.083h4.782l-.623 4.829h-4.16v12.392h8.155c.975 0 1.766-.791 1.766-1.766v-28.468c0-.976-.791-1.766-1.766-1.766z" />;
    case TYPES.LINKEDIN:
      return <path d="M29.63 0h-27.268c-1.304 0-2.362 1.034-2.362 2.306v27.385c0 1.274 1.058 2.309 2.362 2.309h27.268c1.305 0 2.37-1.035 2.37-2.309v-27.385c0-1.272-1.065-2.306-2.37-2.306zm-20.139 27.268h-4.748v-15.271h4.748v15.271zm-2.374-17.359c-1.521 0-2.751-1.233-2.751-2.753 0-1.518 1.23-2.751 2.751-2.751 1.517 0 2.751 1.233 2.751 2.751 0 1.52-1.233 2.753-2.751 2.753zm20.15 17.359h-4.741v-7.426c0-1.772-.035-4.05-2.467-4.05-2.47 0-2.847 1.929-2.847 3.921v7.554h-4.745v-15.271h4.553v2.086h.065c.634-1.2 2.182-2.466 4.491-2.466 4.803 0 5.69 3.162 5.69 7.276v8.376z" />;
    case TYPES.GITHUB:
      return <path d="M15.999 0c-8.835 0-15.999 7.163-15.999 16.001 0 7.068 4.584 13.065 10.943 15.181.8.147 1.092-.347 1.092-.771 0-.38-.014-1.386-.022-2.721-4.451.967-5.39-2.145-5.39-2.145-.728-1.848-1.776-2.34-1.776-2.34-1.453-.993.11-.973.11-.973 1.606.113 2.451 1.649 2.451 1.649 1.427 2.445 3.745 1.739 4.656 1.329.145-1.034.559-1.739 1.016-2.139-3.553-.404-7.288-1.776-7.288-7.908 0-1.747.623-3.175 1.647-4.293-.164-.405-.713-2.032.157-4.234 0 0 1.343-.43 4.4 1.64 1.276-.355 2.645-.532 4.006-.539 1.359.006 2.728.184 4.006.539 3.055-2.07 4.396-1.64 4.396-1.64.873 2.203.324 3.83.159 4.234 1.025 1.119 1.645 2.547 1.645 4.293 0 6.147-3.741 7.499-7.305 7.895.575.494 1.086 1.47 1.086 2.963 0 2.139-.02 3.865-.02 4.389 0 .428.288.926 1.1.769 6.352-2.12 10.933-8.113 10.933-15.18 0-8.838-7.164-16.001-16.001-16.001z" />;
    case TYPES.YOUTUBE:
      return (
        <path d="M24.909 6.208v2.746c0 .639-.151.883-.484.883-.19 0-.41-.098-.603-.291l.001-3.873c.193-.191.411-.291.602-.291.334 0 .484.188.484.826zm4.279-.059c0-.59-.153-.768-.536-.768-.386 0-.55.163-.55.76v.706l1.086-.001v-.697zm2.812-.196v1.44c0 1.536-.191 3.073-.191 3.073s-.186 1.308-.758 1.885c-.725.756-1.538.76-1.911.804-2.669.192-6.676.198-6.676.198s-4.959-.045-6.484-.191c-.424-.079-1.378-.055-2.103-.811-.572-.576-.758-1.885-.758-1.885s-.191-1.536-.191-3.073v-1.441c0-1.536.191-3.073.191-3.073s.186-1.308.758-1.885c.725-.756 1.538-.76 1.911-.804 2.669-.192 6.672-.192 6.672-.192h.008s4.003 0 6.672.192c.373.044 1.186.048 1.911.804.572.576.758 1.885.758 1.885s.19 1.536.19 3.073zm-14.883-2.492h1.405v-1.213l-4.024.001v1.212h1.341v7.345h1.277v-7.345zm4.599.958h-1.214v4.854c-.257.362-.467.564-.699.564-.154 0-.23-.066-.259-.245 0-.064 0-.176 0-.447v-4.726h-1.214v5.046c0 .443.056.745.135.939.13.318.389.494.762.494.425 0 .815-.266 1.275-.794v.703h1.214v-6.387zm4.407 1.916c0-.605-.077-1.018-.155-1.275-.154-.478-.464-.744-.924-.744-.425 0-.848.262-1.222.721l.001-2.79h-1.15v8.559h1.15l.002-.643c.386.478.808.725 1.219.725.46 0 .797-.246.951-.721.077-.271.128-.687.128-1.277v-2.555zm1.98 2.616v-1.147h2.301v-1.306c0-.682-.134-1.181-.376-1.504-.324-.437-.784-.668-1.365-.668-.59 0-1.051.231-1.385.668-.246.323-.389.85-.389 1.532v2.235c0 .678.158 1.153.403 1.472.334.436.795.654 1.4.654.604 0 1.079-.228 1.399-.692.141-.205.231-.436.27-.693.01-.116.041-.38.041-.752v-.181h-1.214c0 .464.002.74-.009.803-.066.309-.232.464-.517.464-.397 0-.564-.297-.56-.886z" />
      );
    default:
      throw new Error(`Invalid icon type: ${type}`);
  }
}



// WEBPACK FOOTER //
// ../components/Icon/Icon.jsx